module.exports = __webpack_public_path__ + "img/03.21fef9e5.png";